/* eslint-disable quotes */
<template>
	<Transition name="nav-slide" mode="out-in">
		<div class="navbar-wrapper" v-if="show">
			<div class="d-flex justify-content-end mb-2" v-if="isAdminLoggedInAsUser" style="color: red">
				Temporarily logged in as user [{{ user.user_id }}] [{{ user.username }}]
			</div>
			<nav
				class="navbar d-flex justify-content-between align-items-center"
				v-if="productEditorPreviewAvailable && showProductEditorNavigation && isMobile && user"
			>
				<div @click="goBack" class="back-button">
					<InlineSvg src="/images/ic-left-arrow.svg" class="back-icon" />
				</div>
				<div @click="togglePreview" class="preview-button">
					<span> Preview </span>
					<InlineSvg src="/images/icon-mobile.svg" class="preview-icon" />
				</div>
			</nav>
			<nav class="navbar d-flex" v-else-if="user">
				<div class="d-inline-flex" v-if="showBreadcrumbs">
					<Breadcrumb :route="$route" @activeTab="activeTab" />
				</div>
				<div class="logo d-flex col-auto p-0" v-else>
					<RouterLink :to="{ name: 'dashboard' }">
						<img src="/images/stan-logo-text.svg" class="mr-2" />
					</RouterLink>
				</div>
				<div
					v-if="user && user.username"
					class="ml-sm-auto sharelinkmobile tooltip-share-storelink px-0 col col-sm-auto d-flex justify-content-end align-items-center"
				>
					<div v-if="storePreviewAvailable && isMobile" @click="togglePreview" class="preview-button">
						<span> Preview </span>
						<InlineSvg src="/images/icon-mobile.svg" class="preview-icon" />
					</div>
					<p
						class="text-truncate mb-0 w-100 align-items-center d-none d-sm-flex"
						style="text-align: right;"
						:key="displayUrl"
						v-if="!isAffiliateOnly"
					>
						<a :href="displayUrl" target="_blank" class="text-truncate h4-md h5 text-bold text-primary-color">{{
							removeHttps(displayUrl)
						}}</a>
					</p>
					<a :href="displayUrl" target="_blank" class="d-flex d-sm-none">
						<InlineSvg class="copy-icon stan-icon stan-icon-primary mr-1 cur" src="/images/icons/ic-link-purple.svg" />
					</a>

					<AppButton class="share-button-navbar stan-icon-wrapper px-2" link @click="copyTextToClipboard" v-if="!isAffiliateOnly">
						<InlineSvg class="copy-icon stan-icon stan-icon-primary" src="/images/icons/ic-copy.svg" />
					</AppButton>
				</div>
			</nav>
			<MobileStorePreviewOverlay ref="storePreviewOverlay" v-if="storePreviewAvailable">
				<StorePreview :user="user" :sections="sectionWithPages" class="mobile-preview" :features="getStoreFeatures" />
			</MobileStorePreviewOverlay>
		</div>
	</Transition>
</template>
<script>
	import { mapGetters, mapActions, mapMutations } from 'vuex'
	import Vue from 'vue'
	import { directive as onClickOutside } from 'vue-on-click-outside'
	import helpers from '~/global_helper/helpers.js'
	import Breadcrumb from '~/components/Breadcrumb'
	import MobileStorePreviewOverlay from '~/pages/stores/components/MobileStorePreviewOverlay'

	Vue.directive('on-click-outside', onClickOutside)

	export default {
		middleware: 'auth',
		components: {
			Breadcrumb,
			MobileStorePreviewOverlay,
		},
		props: {
			show: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return { windowWidth: window.innerWidth }
		},
		created() {
			if (this.user && this.user.status === '0') this.logout()
			// Base spacer for top navigation bar
			document.documentElement.style.setProperty('--navbar-dynamic-offset', '50px')
		},
		computed: {
			...mapGetters('Auth', ['user', 'isAdminLoggedInAsUser']),
			...mapGetters('Global', [
				'getBreadcrumbs',
				'getPageURL',
				'showProductEditorNavigation',
				'showProductEditorPreview',
				'showNavigation',
				'showPreview',
			]),
			...mapGetters('Communities', ['community', 'communityName', 'communityIsActive', 'getCommunities']),
			...mapGetters('Stores', [
				'getStorePublishedPages',
				'getStoreType',
				'getStore',
				'getStoreId',
				'getStoreFeatures',
				'getStoreSections',
				'getStorePagesWithSections',
				'getStorePages',
				'getStoreLandingPages',
			]),
			breadcrumbs() {
				if (this.getBreadcrumbs && this.getBreadcrumbs.length > 0) {
					return this.getBreadcrumbs
				}
				return this.$route.meta.breadcrumbs
			},
			notNewUserHoldout() {
				return !this.user.experiments.new_user_hold_out
			},
			hasProductEditor2025() {
				return this.user?.experiments.digital_product_editor_v2 === 1 || this.user?.experiments.digital_product_editor_v3 === 1
			},
			displayUrl() {
				if (this.$route.name === 'linksite_edit_page' && this.getPageURL) {
					return this.getPageURL
				}
				return this.storeUrl
			},
			routeTitle() {
				return this.$route?.meta?.pageTitle
			},
			storeUrl() {
				return `${this.siteSettings.frontDomain}${this.user.username}`
			},
			storePagesWithSections: {
				get() {
					return this.getSortedPages(this.getStorePagesWithSections)
				},
				set(pages_) {
					this.setStorePagesWithSections(pages_)
				},
			},
			sectionWithPages() {
				// Section Published Status = 1
				const sections = [...this.storePagesWithSections.filter(p => p.section_id !== undefined)]

				if (sections.length === 0) {
					// If no section found, Add one at the top and have all pages added to that section.
					sections.push({
						section_id: -1,
						store_id: this.getStoreId,
						status: 1,
						order: 0,
						data: {},
					})
					// storePagesWithSections should only have pages as it did not had the sections. So lets add all pages with status == 2
					sections[0].pages = [...this.storePagesWithSections.filter(p => p.status === 2)]
				} else {
					// If no section at the top of the page, then add Psuedo section, and add all non-section based pages to it
					if (sections[0].order !== 1) {
						sections.unshift({
							section_id: -1,
							store_id: this.getStoreId,
							status: 1,
							order: 0,
							data: {},
						})
					}
					const totalSections = sections.length
					sections.forEach((section, idx) => {
						const orderStart = section.order
						const orderEnd = idx + 1 < totalSections ? sections[idx + 1].order : 9999
						section.pages = [...this.storePagesWithSections.filter(p => p.status === 2 && p.order >= orderStart && p.order < orderEnd)]
					})
				}

				return sections
			},
			isAffiliateOnly() {
				return this.user.subscription_tier === this.$constants.TIER.AFFILIATE
			},
			isMobile() {
				return this.windowWidth <= 991
			},
			showBreadcrumbs() {
				if (!this.breadcrumbs) {
					return false
				}
				if (!this.isMobile) {
					return true
				}
				return this.breadcrumbs.length > 1
			},
			storePreviewAvailable() {
				return this.notNewUserHoldout && (this.$route.name === 'linksites' || this.$route.name === 'linksite_add_page')
			},
			sbChallengeExperiment() {
				return this.user?.experiments?.steven_bartlett_challenge_experiment
			},
			productEditorPreviewAvailable() {
				return this.notNewUserHoldout || this.hasProductEditor2025 || this.sbChallengeExperiment
			},
		},
		methods: {
			...mapActions('Auth', ['fetchUser']),
			...mapMutations('Global', ['setBreadcrumbs', 'setShowNavigation', 'setShowPreview', 'setShowProductEditorPreview']),
			getSortedPages(pages) {
				let order = 1

				return pages
					.map(page => {
						if (page.section_id !== undefined) {
							// This means its section
							page.order = order
							order++
							return page
						}

						let pageDefault = this.$constants.PAGE_DEFAULTS.default
						if (page.type in this.$constants.PAGE_DEFAULTS) {
							pageDefault = this.$constants.PAGE_DEFAULTS[page.type]
						}
						page.icon_page_list = pageDefault.icon

						if (typeof page.bottom_title === 'undefined' || page.bottom_title === '') {
							page.bottom_title = pageDefault.bottom_title
						}
						page.page_list_title = page.data.product.title || page.data.bottom_title
						if (this.isStoreLinkSite && page.data.location === 'store') {
							const title = helpers.getStorePageListTitle(page)
							if (title) {
								page.page_list_title = title
							}
						}
						page.order = order
						order++
						return page
					})
					.sort((a, b) => a.order - b.order)
			},
			removeHttps(url) {
				return url.replace(/^https?:\/\//, '')
			},
			async logout() {
				clearInterval(this.t)
				await this.$store.dispatch('Auth/logout')
				localStorage.clear()
				this.$router.push({ name: 'login_page' }).catch(() => {})
			},
			closeMenu() {
				this.setShowNavigation(false)
			},
			togglePreview() {
				if (this.storePreviewAvailable) {
					this.closeMenu()
					this.$refs.storePreviewOverlay.toggleVisible()
				} else {
					this.setShowProductEditorPreview(!this.showProductEditorPreview)
				}
			},
			clipboardSuccessHandler() {
				this.$stanNotify({
					type: 'success', // can be 'info', 'warning', 'success', 'error'
					title: this.$t('URL Copied!'),
					duration: 3000,
				})
				this.$stanAnalytics('link-shared', {
					meta: { user_id: this.user.user_id, username: this.user.username },
				})
			},
			activeTab(tabName, query, params) {
				this.$router.push({ name: tabName, query, params }).catch(() => {})
			},
			updateWindowWidth() {
				this.windowWidth = window.innerWidth
			},
			goBack() {
				if (this.showProductEditorPreview) {
					this.togglePreview()
				} else {
					this.$router.back()
				}
			},
			async copyTextToClipboard() {
				this.$commonHelper.copyToClipboard(this.displayUrl, this.clipboardSuccessHandler)
			},
		},
		watch: {
			showPreview() {
				$('.mobile-preview-wrapper .site__prev__masking').animate({ scrollTop: 0 }, 0)
			},
		},
		mounted() {
			window.addEventListener('resize', this.updateWindowWidth)
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.updateWindowWidth)
		},
	}
</script>
<style lang="scss" scoped>
	.nav-slide-enter-active,
	.nav-slide-leave-active {
		transition: transform 0.3s ease, opacity 0.3s ease;
	}

	.nav-slide-enter,
	.nav-slide-leave-to {
		transform: translateY(-100%);
		margin-bottom: -50px;
		background-color: white;
	}
	.preview-button {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		gap: 8px;
		margin-right: 10px;
		border-radius: 7px;
		border: 1px solid #b5c2d5;
		color: #03215e;
		padding: 8px 12px;

		:hover {
			cursor: pointer;
		}
	}
	.mobile-preview-wrapper {
		transition: all ease 0.5s;
		position: fixed;
		top: 100%;
		height: 90%;
		left: 0;
		width: 100%;
		padding-bottom: 60px;
		align-items: center;
		background: var(--stan-blue-8);
		will-change: top, left, position, scroll-position;
		-webkit-transform: translateZ(0);
	}

	.preview-active .mobile-preview-wrapper {
		position: relative;
		top: 10px;
		@media (min-width: 992px) {
			position: fixed;
			top: 100%;
			display: none;
		}
	}
	.navbar-wrapper {
		z-index: 1;
		border-bottom: 1px solid var(--stan-primary-light-color);
		position: sticky;
		background: #fff;
		.navbar {
			position: -webkit-sticky;
			position: sticky;
			top: 0px;
			padding-left: 20px;
			max-height: 50px;
			align-items: center;
			display: flex;
			justify-content: space-between;
			flex-wrap: nowrap;
			@media (min-width: 576px) {
				justify-content: flex-end;
			}
			.page-title {
				font-size: 24px;
				font-weight: 300;
				color: var(--stan-white);
			}
		}
		.share-button-navbar {
			white-space: nowrap;
			background: transparent;
			border: none;
			justify-self: flex-end;
			min-width: 24px;
			flex: 0 0 auto;
			width: auto;
			background-color: var(--stan-white);
			width: unset;
			min-width: unset !important;
			@media (min-width: 576px) {
				height: 36px;
				background: var(--stan-white);
				border: 1px solid var(--stan-primary-primary-color);
				color: var(--stan-primary-primary-color);
				justify-self: unset;
				min-width: none !important;
				padding: 0 15px;
				&:hover {
					background-color: var(--stan-primary-light-color);
				}
			}
			border-radius: 10px;
			font-size: 14px;
			line-height: 19px;
			letter-spacing: 0.04em;
			font-weight: 600;

			.vertical-align-middle {
				vertical-align: middle;
			}

			::v-deep {
				svg path {
					fill: var(--stan-primary-primary-color);
				}
			}
		}

		.page-header {
			font-weight: 600;
			font-size: 18px;
			line-height: 25px;
			color: var(--stan-primary-dark-color);
			margin: 0;
		}

		.sharelinkmobile {
			max-width: calc(100% - 95px);
			@media (min-width: 576px) {
				max-width: 35%;
			}
		}
	}

	.back-button::v-deep {
		cursor: pointer;
		.back-icon {
			padding-top: 1px;
			path {
				fill: var(--stan-text-light-color) !important;
			}
		}
	}

	.preview-button::v-deep {
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border: 1px solid #b5c2d5;
		gap: 8px;
		padding-top: 8px;
		padding-right: 12px;
		padding-bottom: 8px;
		padding-left: 12px;
		border-radius: 4px;
		border-width: 1px;

		span {
			font-weight: 500;
			font-size: 14px;
			line-height: 90%;
			letter-spacing: 2%;
			text-align: right;
			color: #03215e;
		}
		.preview-icon {
			height: 16px;
			width: 16px;
			path {
				fill: #03215e !important;
			}
		}
	}
</style>
